import React from 'react'
import { Modal } from 'antd'
import { interestedRequestAddFxn } from '../../actions/cornerStone'
import { useDispatch } from 'react-redux'

const LoaReqMessage = (props) => {
  let { visible, onClose } = props
  let dispatch = useDispatch()
  let events = {
    submitRequest: async () => {
      let resp = await dispatch(interestedRequestAddFxn({ collegeName: 'National College' }))
      if (resp && resp.success) {
        onClose()
      }
    }
  }
  return (
    <Modal
      title='National College Account not activated.'
      visible={visible}
      onOk={onClose}
      footer={false}
      width={'40%'}
      onCancel={onClose}>
      <div style={{ fontSize: 16 }} className={'alignCenter'}>
        <img src={'../assets/directUniversities/nationalCollege.png'} style={{ height: 120 }} />

        <div className={'mt20'}>
          Click this link to open your <strong>National College</strong> login.
        </div>
        <div className={'mt20'}>
          <a className={'btn btn-link'} onClick={events.submitRequest}>click here</a>
        </div>
      </div>
    </Modal>
  )
}
export default LoaReqMessage
